
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StickyCTA from '../../components/feature/StickyCTA';
import InvestimentoHeroSection from './components/InvestimentoHeroSection';
import InscricaoFormSection from './components/InscricaoFormSection';

export default function InvestimentoPage() {
  return (
    <>
      <Navbar />
      <main className="pt-20">
        <InvestimentoHeroSection />
        <InscricaoFormSection />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}
